import Vue from "vue";
import ApiService from "@/services/api.service";
import { FETCH_UNITS, FETCH_UNITS_DEPARTMENT } from "./actions.type";
import { RESET_STATE, SET_UNIT } from "./mutations.type";

const initialState = {
  units: []
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_UNITS_DEPARTMENT](context, unitSlug) {
    const { data } = await ApiService.get("units", unitSlug);
    context.commit(SET_UNIT, data.units);
    return data;
  },
  async [FETCH_UNITS](context, unitSlug) {
    const { data } = await ApiService.get("units");
    context.commit(SET_UNIT, data.units);
    return data;
  },
  [RESET_STATE]({ commit }) {
    commit(RESET_STATE);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SET_UNIT](state, units) {
    state.units = units;
  },
  [RESET_STATE]() {
    for (let f in state) {
      Vue.set(state, f, initialState[f]);
    }
  }
};

const getters = {
  unit(state) {
    return state.units;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
